import { OfferingWritingCompanyItem } from '@models/productOffering';
import { Select } from '@components/index';
import { useStore } from '@store/GlobalStore';
import { Box } from '@mui/material';
import { boxStyles, paperProps } from '@pages/NewQuote/scope/ScopePanel.styles';
import { useNewQuoteStore } from '@store/NewQuote';
import { shallow } from 'zustand/shallow';
import { useWritingCompany } from '@services/writingCompany';
import { useGetScreenSize } from '@utils/useGetScreenSize';

type TWritingCompanySelection = {
  handleWritingCompanyChange: (selectedValue: any) => void;
};
export const WritingCompanySelection = ({ handleWritingCompanyChange }: TWritingCompanySelection) => {
  const { scope } = useNewQuoteStore();
  const { isMobileScreen } = useGetScreenSize();
  const { isInternalUser } = useStore((state) => state.userAuth, shallow);
  const { productOffering, writingCompany } = scope;
  const { writingCompanies } = useWritingCompany(isInternalUser, productOffering?.value);
  const defaultWritingCompany = writingCompanies?.items?.find((p: OfferingWritingCompanyItem) =>
    p.isDefault ? p.writingCompany : undefined,
  );

  return isInternalUser && productOffering && !!writingCompanies ? (
    <Box sx={boxStyles}>
      <Select
        sx={{ width: '300px' }}
        fullWidth={isMobileScreen}
        inputLabel='Writing Company'
        data-testid='Writing Company'
        items={writingCompanies?.items?.map((item: OfferingWritingCompanyItem) => ({
          key: item.id,
          value: item.writingCompany.id,
          label: item.writingCompany.name,
          ...item,
        }))}
        MenuProps={{
          ...paperProps,
        }}
        value={writingCompany?.id ?? defaultWritingCompany?.writingCompany?.id}
        onChangeSelect={(eventValue) => {
          const selectedValue = writingCompanies?.items?.find(
            (p: OfferingWritingCompanyItem) => p?.writingCompany.id === eventValue,
          );
          if (selectedValue) {
            handleWritingCompanyChange(selectedValue.writingCompany);
          } else {
            handleWritingCompanyChange(defaultWritingCompany);
          }
        }}
      />
    </Box>
  ) : null;
};
